import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const faqs = [
  {
    q: "¿Qué tipo de empresas pueden trabajar contigo?",
    a: "Trabajo principalmente con empresas medianas y grandes, equipos comerciales con 5+ personas y operaciones que ya invierten en publicidad. Si tu negocio depende de generar y atender leads de forma consistente, encajamos.",
  },
  {
    q: "¿Implementas Respond.io de extremo a extremo?",
    a: "Sí. Configuro la cuenta, integraciones, automatizaciones, IA conversacional, reportes y entreno a tu equipo. No te dejo a medias: tu operación queda funcionando.",
  },
  {
    q: "¿Trabajas campañas de Meta, Google y TikTok Ads?",
    a: "Sí. Combino Google Ads, Meta Ads y TikTok Ads con automatización para que cada lead que llega entre a un sistema diseñado para convertir, no a una bandeja olvidada.",
  },
  {
    q: "¿Cuánto tarda una automatización completa?",
    a: "Depende del alcance. Un chatbot enfocado puede salir en 2 semanas; una implementación completa de Respond.io con campañas y CRM, entre 4 y 8 semanas.",
  },
  {
    q: "¿Se puede integrar con mi CRM?",
    a: "Sí. Integro con HubSpot, Pipedrive, Notion, Google Sheets, ERPs custom y prácticamente cualquier sistema que exponga API o webhooks.",
  },
  {
    q: "¿Trabajas funnels completos o solo partes sueltas?",
    a: "Mi diferencial es el funnel completo: tráfico → automatización → calificación → ventas. También acepto proyectos puntuales si tienes el resto resuelto.",
  },
  {
    q: "¿La atención es personalizada?",
    a: "Sí. Trabajo con un número limitado de cuentas a la vez. Tú hablas conmigo, no con un account manager.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 reveal">
            <div className="eyebrow mb-5">Preguntas frecuentes</div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
              Respuestas claras antes de la <span className="text-gradient">consultoría</span>.
            </h2>
            <p className="mt-6 text-zinc-400 text-base max-w-md">
              Si tu duda no está aquí, escríbeme directo por WhatsApp y la resolvemos.
            </p>
          </div>
          <div className="lg:col-span-7 reveal">
            <Accordion type="single" collapsible className="space-y-2" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="grad-border px-5 sm:px-6 border-b-0"
                >
                  <AccordionTrigger className="text-left text-white hover:no-underline font-display font-semibold text-[15px] sm:text-base py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-zinc-400 text-[14.5px] leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
